<template>
    <section class="ad-consult-sec">
        <div class="ad-consult-box">
             <p v-html="text"></p>
             <div class="ad-consult-btn">
                <a :href="isLoggedIn ? campaignPath : loginPath" class="btn btn--primary">
                    <span> شروع تبلیغ </span>
                    <img src="../assets/images/login-bold-duotone.svg" class="icon" />
                </a>
                <button class="btn btn--consult" @click.stop="openModal">مشاوره رایگان</button>
             </div>
        </div>
        <ModalBox :isModalOpen="showModal" @close="closeModal"></ModalBox>
    </section>
</template>

<script>
import ModalBox from './ModalBox.vue';
import { useModal } from '@/useModal';
import { ref, inject } from 'vue';
export default {
    name: "AdConsult",
    components: {
        ModalBox,
    },
    props: {
        text: {
          type: String,
          required: true
        },
      },
    setup() {
        const isLoggedIn = inject('isLoggedIn', ref(false));
        const campaignPath = inject('campaignPath');
        const loginPath = inject('loginPath');

        const { showModal, openModal, closeModal } = useModal();

        return {
            isLoggedIn,
            campaignPath,
            loginPath,
            showModal,
            openModal,
            closeModal,
        }

    }
};
</script>

<style scoped>
.ad-consult-sec {
    width: 100%;
    background-image: url('../assets/images/section-bg-4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-block: 13px 53px;
}

.ad-consult-box {
    max-width: 802px;
    margin-inline: 22.16%;
    padding: 6% 9.03%;
    border-radius: 20px;
    backdrop-filter: blur(20px);
    background-color: var(--glass-morphism);
    box-shadow: 0 2px 10px var(--shadow-light);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ad-consult-box p {
    text-align: justify;
    font-size: 20px;
    margin-bottom: 4.44%;
}

.ad-consult-btn {
    display: flex;
    justify-content: center;
    gap: 24px;
}

@media screen and (min-width:1441px) {
    .ad-consult-box {
        margin-inline: auto;
        padding: 89px 130px;
    }
}

@media screen and (max-width:1024px) {
    .ad-consult-sec {
         background-image: none;
    }

    .ad-consult-box {
        margin-inline: 19.16%;
    }

    .ad-consult-box p {
        font-size: 18px;
    }
}

@media screen and (max-width:768px) {
    .ad-consult-sec {
        padding-block: 14.5px;
    }

    .ad-consult-box {
        margin-inline: 6%;
        padding: 30px 10px;
    }

    .ad-consult-box p {
       line-height: 26px;
        font-size: 16px;
    }

}

@media screen and (max-width:360px) {
    .ad-consult-box {
        margin-inline: 4%;
    }
}
</style>